import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router";
import useSWR from "swr";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import smarTracksMapTheme from "./utils/theme";
import Root from "./components/Root/Root";
import GenericError from "./components/GenericError/GenericError";
import ApiConfiguration from "./services/apiConfiguration";
import { getSportsLocations } from "./services/SportsLocation/SportsLocation.service";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter7Adapter } from "./adapters/ReactRouter7Adapter";

import "./MapStyleOverrides.css";
import Format from "string-format";

function App() {
  const [retryCount, setRetryCount] = React.useState<number>(0);

  /**
   * Using stale-while-revalidate to always provide the application
   * with the latest of all sports locations.
   * This respects http caching of locations on the api side.
   */
  const { data, error } = useSWR(
    Format(
      ApiConfiguration.GET_SPORTS_LOCATIONS_URL,
      ApiConfiguration.getApiUrl(),
    ),
    () => getSportsLocations(),
    {
      onErrorRetry: (error, key, option, revalidate, { retryCount }) => {
        console.log(key, option);
        if (error) console.log(error);
        if (!retryCount) return;
        setRetryCount(retryCount);
        if (retryCount >= 3) return;
        if (error.status === 404) return;

        // retry after 5 seconds
        setTimeout(() => revalidate({ retryCount }), 5000);
      },
    },
  );

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={smarTracksMapTheme}>
          {!error && (
            <Router>
              <QueryParamProvider adapter={ReactRouter7Adapter}>
                <Routes>
                  <Route path="*" element={<Root data={data} />} />
                  <Route path="*/@:latLngZoom" element={<Root data={data} />} />
                </Routes>
              </QueryParamProvider>
            </Router>
          )}
          {!data && error && <GenericError retrying={retryCount < 3} />}
        </ThemeProvider>
      </StyledEngineProvider>
    </Suspense>
  );
}

export default App;
